import axios from '@/request';
import * as model from '@/models/user.models';
import { request } from '@/utils/request';
/** 查询当前登录用户的角色 */
export async function getAccountList() {
  const result: model.IMessageAccountListVO = await request.get('/rest/merchant/account/queryAccountList')
  return result;
}